export type StickyCtaEntry =
  { text: string; href: string } | { text: string; form: 'contact' };

const JOIN_NOW: StickyCtaEntry = {
  text: 'Join Now',
  href: '/intake-v2/signup-type',
};

export const STICKY_CTA_BY_SLUG: Record<string, StickyCtaEntry> = {
  '': JOIN_NOW,
  membership: JOIN_NOW,
  locations: JOIN_NOW,
  'locations/upper-east-side': JOIN_NOW,
  'locations/fifth-avenue-center': JOIN_NOW,
  'locations/tribeca': JOIN_NOW,
  'locations/gramercy': JOIN_NOW,
  'locations/hudson-yards-center': JOIN_NOW,
  'locations/hamptons': JOIN_NOW,
  'locations/beverly-hills': JOIN_NOW,
  'locations/santa-monica': JOIN_NOW,
  'locations/manhattan-beach-center': JOIN_NOW,
  'locations/san-francisco': JOIN_NOW,
  'locations/palo-alto-center': JOIN_NOW,
  'locations/palm-beach': JOIN_NOW,
  'locations/boca-raton-center': JOIN_NOW,
  'locations/coral-gables': JOIN_NOW,
};

export function getStickyCtaForSlug(
  slug: string[] | undefined
): StickyCtaEntry | null {
  if (!slug) return null;
  return STICKY_CTA_BY_SLUG[slug.join('/')] ?? null;
}
